// helpers
import { pagesUrl, appSection, hotelPanelRootUrl } from "../../utils/panel-helpers/helpers";
import ApiHelper from "../../utils/apiHelper";
// actions
import { globalActionCreators } from "./globalModule";

export const loginsActionTypes = {
  CALL_LOGINS: "CALL_LOGINS",
  SET_SELECTED_LOGIN: "SET_SELECTED_LOGIN"
};

export const initialState = {
  logins: [],
  selectedLogin: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case loginsActionTypes.CALL_LOGINS:
      return {
        ...state,
        logins: action.logins
      };
    case loginsActionTypes.SET_SELECTED_LOGIN:
      return {
        ...state,
        selectedLogin: action.selectedLogin
      };

    default:
      return state;
  }
};

export const loginsActionCreators = {
  setSelectedLoginAction: selectedLogin => {
    return {
      type: loginsActionTypes.SET_SELECTED_LOGIN,
      selectedLogin
    };
  },
  loadLoginsAction: (hotelId, callSectionLoader) => async (dispatch, getState) => {
    const sectionLoadingNamesState = getState().global.sectionLoadingNames;
    if (sectionLoadingNamesState?.includes(appSection?.logins)) {
      // disable new API call if we are still waiting for response
      return;
    }

    const isHotelGroupExistsState = getState().home.isHotelGroupExists;
    const hotelIdParam = isHotelGroupExistsState && hotelId ? `?hotelId=${hotelId}` : "";

    callSectionLoader(true, appSection?.logins);

    try {
      const res = await ApiHelper.get(`/v1/logins${hotelIdParam}`);

      dispatch({
        type: loginsActionTypes.CALL_LOGINS,
        logins: res?.data
      });
    } catch (error) {
      dispatch(globalActionCreators.handleErrorAction());
    } finally {
      callSectionLoader(false, appSection?.logins);
    }
  },
  addLoginsAction:
    (
      loginName,
      loginEmail,
      loginPhone,
      loginManagerAccess,
      loginPassword,
      onHandleFormMessage,
      onLoadLogins,
      navigate
    ) =>
    async (dispatch, getState) => {
      const isHotelGroupExistsState = getState().home.isHotelGroupExists;
      const selectedHotelsState = getState().global.selectedHotels;

      try {
        let bodyFormData = {
          fullName: loginName,
          email: loginEmail,
          phoneNumber: loginPhone,
          plainPassword: loginPassword,
          hotelManager: loginManagerAccess ? 1 : 0
        };

        if (isHotelGroupExistsState) {
          bodyFormData = {
            ...bodyFormData,
            hotelId: selectedHotelsState[0]?.id
          };
        }

        const res = await ApiHelper.post(`/v1/login/new`, {}, JSON.stringify(bodyFormData));

        onHandleFormMessage(res.data.status, "AddLogin");
        isHotelGroupExistsState ? onLoadLogins(selectedHotelsState[0]?.id) : onLoadLogins();
        navigate(`/${hotelPanelRootUrl}/${pagesUrl.logins}`);
      } catch (error) {
        console.log(error);
      }
    },
  updateLoginsAction:
    (
      loginName,
      loginEmail,
      loginPhone,
      loginManagerAccess,
      loginPassword,
      onHandleFormMessage,
      onLoadLogins,
      navigate
    ) =>
    async (dispatch, getState) => {
      const isHotelGroupExistsState = getState().home.isHotelGroupExists;
      const selectedHotelsState = getState().global.selectedHotels;
      const selectedLoginIdState = getState().logins.selectedLogin.id;

      try {
        let bodyFormData = {
          fullName: loginName,
          email: loginEmail,
          phoneNumber: loginPhone,
          plainPassword: loginPassword,
          hotelManager: loginManagerAccess ? 1 : 0
        };

        if (isHotelGroupExistsState) {
          bodyFormData = {
            ...bodyFormData,
            hotelId: selectedHotelsState[0]?.id
          };
        }

        const res = await ApiHelper.post(`/v1/login/edit/` + selectedLoginIdState, {}, JSON.stringify(bodyFormData));

        onHandleFormMessage(res.data.status, "EditLogin");
        isHotelGroupExistsState ? onLoadLogins(selectedHotelsState[0]?.id) : onLoadLogins();
        navigate(`/${hotelPanelRootUrl}/${pagesUrl.logins}`);
      } catch (error) {
        console.log(error);
      }
    },
  deleteLoginAction: (onHandleFormMessage, onLoadLogins, navigate) => async (dispatch, getState) => {
    const isHotelGroupExistsState = getState().home.isHotelGroupExists;
    const selectedHotelsState = getState().global.selectedHotels;
    const selectedLoginIdState = getState().logins.selectedLogin.id;

    try {
      const res = await ApiHelper.get(`/v1/login/remove/` + selectedLoginIdState);

      onHandleFormMessage(res.data.status, "DeleteLogin");
      isHotelGroupExistsState ? onLoadLogins(selectedHotelsState[0]?.id) : onLoadLogins();
      navigate(`/${hotelPanelRootUrl}/${pagesUrl.logins}`);
    } catch (error) {
      console.log(error);
    }
  }
};
